// GlobalDialog.js
import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";

const GlobalPopup = ({
  visible,
  title,
  content,
  onHide,
  footerButtons,
  Popupwidth,
  Popupheight,
  position,
  dismissableMask,
  draggable,
  id,
}) => {
  return (
    <Dialog
      id={id}
      header={title}
      visible={visible}
      closable={true}
      draggable={draggable}
      onHide={onHide}
      footer={footerButtons}
      position={position}
      dismissableMask={dismissableMask}
      //breakpoints={{ "960px": "75vw", "640px": "100vw" }}
      style={{
        minWidth: "30vw",
        width: Popupwidth,
        height: Popupheight,
      }}
    >
      {content}
    </Dialog>
  );
};

export default GlobalPopup;
